import React, { useEffect, useRef, useState } from "react";
import store from "Redux/Store/AppStore";
import InsuranceService from "Services/InsuranceService/InsuranceService";
import { useBilling } from "Shared/hooks/useBilling";
import {
  getToxReflexToConfirmationIndex,
  getToxTestingOption,
  isRepeatFieldVisible,
} from "../../../Utils/Common/Requisition";
import useLang from "./../../hooks/useLanguage";

const Radio2 = (props: any) => {
  const [touch, setTouch] = useState(false);
  const { t } = useLang();
  // const defaultSetMapRef = useRef<{ [fieldName: string]: boolean }>({});
  const { addBillingInfo, removeBillingInfo } = useBilling();
  let backup: any[] = [];
  const divElement = useRef<HTMLDivElement | null>(null); // Initialize ref for div
  useEffect(() => {
    // Scroll to the div if props.error is present
    if (props.error && divElement.current) {
      divElement.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    props.setErrorFocussedInput && props.setErrorFocussedInput();
  }, [props?.errorFocussedInput]);

  let inputsCopy = JSON?.parse(JSON?.stringify(props?.Inputs));
  let toxtestingoptionindex = getToxTestingOption(inputsCopy);

  const fetchedOptions = useRef(false);

  // Fetch insurance providers based on insurance ID
  const getOptions = async (id: any) => {
    fetchedOptions.current = true;
    try {
      const res = await InsuranceService.GetInsuranceProvidersDropdown(id);
      return res?.data;
    } catch (err) {
      console.error("Error fetching insurance providers", err);
    }
  };

  const resolveSelectedRadioOption = () => {
    if (!props?.RadioOptions?.length) return null;

    const normalizedDefault = props?.defaultValue
      ? String(props.defaultValue).split(" ").join("").toLowerCase()
      : "";

    if (normalizedDefault) {
      return (
        props.RadioOptions.find(
          (option: any) =>
            String(option?.value || "")
              .split(" ")
              .join("")
              .toLowerCase() === normalizedDefault ||
            String(option?.label || "")
              .split(" ")
              .join("")
              .toLowerCase() === normalizedDefault
        ) ?? null
      );
    }

    return (
      props.RadioOptions.find((option: any) => option?.isSelectedDefault) ??
      null
    );
  };

  const persistBillingInsuranceIds = (choice: any) => {
    if (!choice) return;
    localStorage.setItem("insurnceID", String(choice?.id ?? ""));
    localStorage.setItem("insuranceOptionId", String(choice?.optionDataID ?? ""));
  };

  const autoBillingSelection = async () => {
    if (props?.name !== "BillingType") return;

    const billingSelected = resolveSelectedRadioOption();
    if (!billingSelected) return;

    persistBillingInsuranceIds(billingSelected);

    const response = await getOptions(billingSelected?.optionDataID);
    addBillingInfo(props?.fieldIndex, response);
  };

  useEffect(() => {
    // this is for pre-fetching insurance
    autoBillingSelection();
  }, [props.defaultValue]);

  useEffect(() => {
    if (props.defaultValue === "Samplenotcollected") {
      props?.Inputs[FindIndex(props.Inputs, 4)].fields.forEach((i: any) => {
        if (
          i.systemFieldName === "DateofCollection" ||
          i.systemFieldName === "TimeofCollection" ||
          i.systemFieldName === "DateReceived" ||
          i.systemFieldName === "CollectorID" ||
          i.systemFieldName === "StatOrder" ||
          i.systemFieldName === "CollectedBy"
        ) {
          // Modify the field
          i.visible = false;
        }
      });
    }
  }, [props.defaultValue]);

  // Add this new function before emptySectionOnBillingType
  const resetRepeatFields = () => {
    if (
      props?.Inputs[props?.index]?.fields[props?.fieldIndex]?.repeatFields[
        props?.repeatFieldIndex
      ]?.systemFieldName === "BillingType"
    ) {
      props?.Inputs[props?.index].fields[
        props?.fieldIndex
      ].repeatFields.forEach((i: any) => {
        if (i.systemFieldName === "BillingType") return;
        i.defaultValue = "";
        i.selectedText = "";
        if (i.systemFieldName === "InsuranceProviderID") {
          i.options = [];
        }
      });
      // Update setInputs in the reset function to ensure state is updated even if below code errors
      props?.setInputs(props?.Inputs);
    }
  };

  const emptySectionOnBillingType = async (
    controlOptionsDependentFieldsList: any
  ) => {
    if (
      props?.Inputs[props?.index]?.fields[props?.fieldIndex]?.repeatFields[
        props?.repeatFieldIndex
      ]?.systemFieldName === "BillingType"
    ) {
      // Call the separate reset function
      resetRepeatFields();

      // Collect matchedFields from all sections, not just patientIndex
      const matchedFields: any[] = [];
      props.Inputs?.forEach((section: any) => {
        section?.fields
          ?.filter((field: any) =>
            controlOptionsDependentFieldsList?.some(
              (dep: any) =>
                dep.systemFieldName?.trim() === field.systemFieldName?.trim()
            )
          )
          .forEach((field: any) => {
            const matchedDep = controlOptionsDependentFieldsList.find(
              (dep: any) =>
                dep.systemFieldName?.trim() === field.systemFieldName?.trim()
            );

            matchedFields.push({
              systemFieldName: field.systemFieldName,
              validationExpression: field.validationExpression,
              dependencyAction: matchedDep?.dependencyAction,
            });
          });
      });

      const existingNames = new Set(backup.map((item) => item.systemFieldName));

      backup = matchedFields.filter(
        (item: any) => !existingNames.has(item.systemFieldName)
      );

      if (controlOptionsDependentFieldsList?.length > 0) {
        // Process all fields across all sections
        const allBackup = JSON.parse(localStorage.getItem("Backup") || "[]");
        props.Inputs?.forEach((section: any) => {
          section?.fields?.forEach((field: any) => {
            const matchedBackup = backup.find(
              (b: any) => b.systemFieldName === field.systemFieldName
            );
            const b = allBackup.find(
              (b: any) => b.systemFieldName === field.systemFieldName
            );

            if (!matchedBackup) return;

            if (matchedBackup.dependencyAction.toLowerCase() === "optional") {
              field.validationExpression = "";
            } else {
              field.validationExpression = b.validationExpression;
            }
          });
        });
      } else {
        const allBackup = JSON.parse(localStorage.getItem("Backup") || "[]");
        // Process all fields across all sections
        props.Inputs?.forEach((section: any) => {
          section?.fields?.forEach((field: any) => {
            const matchedBackup = allBackup.find(
              (b: any) => b.systemFieldName === field.systemFieldName
            );

            if (!matchedBackup) return;

            field.validationExpression = matchedBackup.validationExpression;
          });
        });
      }
      props?.setInputs(props?.Inputs);
    }
  };
  function FindIndex(arr: any[], id: any) {
    return arr.findIndex((i: any) => i.sectionId === id);
  }

  const removeFields = (billingInfoSectionid: number, fieldsId: number) => {
    removeBillingInfo(props.fieldIndex);
    let inputsCopy = [...props.Inputs];
    inputsCopy[fieldsId].fields.splice(billingInfoSectionid, 1);
    props?.setInputs && props?.setInputs(inputsCopy);
  };

  const buildRadioChangeEvent = (choice: any, fieldName: string) => ({
    target: {
      value: choice?.value,
      attributes: {
        "data-name": { value: fieldName },
        "data-id": { value: choice?.id },
        "data-namecheck": { value: props?.name },
        "data-optiondataid": { value: choice?.optionDataID },
        insuranceOptionsId: { value: choice?.optionDataID },
      },
      checked: false,
    },
  });

  const applyBillingTypeSelection = async (choice: any) => {
    await emptySectionOnBillingType(choice.controlOptionsDependentFieldsList);

    const optionDataId = choice?.optionDataID;
    persistBillingInsuranceIds(choice);

    if (
      choice?.value === "Client Bill" ||
      choice?.value === "Self Pay" ||
      choice?.value === "Missing Insurance"
    ) {
      props.setCheckbox?.(true);
      props.setShowButton?.(false);
      props?.Inputs?.[props?.index]?.fields?.forEach(
        (arr: any, index: number) => {
          if (arr.displayFieldName === "Repeat Start" && index !== 0) {
            removeFields(index, props?.index);
          }
        }
      );
    } else {
      props.setCheckbox?.(false);
      props.setShowButton?.(true);
      props.setDisableCheckbox?.(false);
      props.setIns?.(false);
    }

    await addBillingInfo(props?.fieldIndex, []);
    const response = await getOptions(optionDataId);
    await addBillingInfo(props?.fieldIndex, response ?? []);
  };

  /**
   * Filters the tox testing options by specimen type.
   *
   * `resetSelections` must only be true when the user actually changes
   * SpecimenType — the previous Screening choice no longer applies, so it is
   * cleared. The default-selection effect below re-applies an *already
   * selected* specimen type (it re-runs whenever infectiousData is cloned, e.g.
   * on the remount that follows a failed Continue); clearing selections there
   * silently unchecks the Screening panel the user just picked, so that path
   * passes false and only refreshes visibility.
   */
  const applyToxTestingSpecimenTypeFilter = (
    choice: any,
    resetSelections: boolean = true
  ) => {
    const isToxTesting =
      props?.ArrayReqId === 3 && props.systemFieldName === "SpecimenType";

    if (!isToxTesting || !choice) return;

    // Tracks whether the panels actually changed, so the non-resetting path
    // does not re-render infectiousData (and re-arm this effect) on every pass.
    let panelsChanged = false;
    let panelType: any = [];
    const panelTypeSet = new Set<string>();
    props?.Inputs[toxtestingoptionindex]?.fields?.forEach((field: any) => {
      if (field.systemFieldName === "Compendium") {
        if (resetSelections) {
          field.defaultValue = [];
        }
        const panels = field?.panels;
        panels.forEach((panel: any) => {
          let anyTestOptionVisible = false;

          panel.testOptions.forEach((testOption: any) => {
            const specimenType = testOption?.specimenType
              ?.trim()
              ?.toLowerCase();
            const label = choice.label?.trim()?.toLowerCase();

            if (specimenType === label) {
              panelTypeSet.add(panel.panelType);
              if (testOption.isVisible !== true) panelsChanged = true;
              testOption.isVisible = true;
              anyTestOptionVisible = true;
            } else {
              if (testOption.isVisible !== false) panelsChanged = true;
              testOption.isVisible = false;
              // A hidden option can no longer be part of the selection.
              if (!resetSelections && testOption.isSelected) {
                testOption.isSelected = false;
                panelsChanged = true;
              }
            }
          });

          if (panel.isVisible !== anyTestOptionVisible) panelsChanged = true;
          panel.isVisible = anyTestOptionVisible;
          if (!resetSelections && !anyTestOptionVisible && panel.isSelected) {
            panel.isSelected = false;
            panelsChanged = true;
          }
        });
      }
    });
    panelType = Array.from(panelTypeSet);
    props?.Inputs[toxtestingoptionindex]?.fields?.forEach((field: any) => {
      if (field.systemFieldName === "TestingOprtionCheckboxes") {
        field.options.forEach((option: any) => {
          if (panelType.includes(option.name)) {
            option.isVisable = true;
          } else {
            option.isVisable = false;
          }
        });
      }
    });

    if (resetSelections) {
      props?.Inputs[
        getToxReflexToConfirmationIndex(props.Inputs)
      ]?.fields?.forEach((field: any) => {
        field.defaultValue = false;
      });
      props?.Inputs[toxtestingoptionindex]?.fields?.forEach((field: any) => {
        if (field.systemFieldName === "TestingOprtionCheckboxes") {
          field.options.forEach((option: any) => {
            if (option.name.toLowerCase() === "screening") {
              option.isSelectedDefault = false;
            }
          });
        }
      });
      props?.Inputs[toxtestingoptionindex]?.fields?.forEach((field: any) => {
        if (field.systemFieldName === "Compendium") {
          field.panels.forEach((panel: any) => {
            if (panel.panelType.toLowerCase() === "screening") {
              panel.isSelected = false;
              panel.testOptions.forEach((testOption: any) => {
                testOption.isSelected = false;
              });
            }
          });
        }
      });
    }

    // Nested tox Inputs are ReqConfig.sections — never pass them to parent setInputs
    // (that would replace the whole form). Refresh infectiousData to re-render panels.
    if (
      (resetSelections || panelsChanged) &&
      props?.ArrayReqId &&
      props?.setInfectiousData &&
      props?.infectiousData
    ) {
      props.setInfectiousData([...props.infectiousData]);
    }
  };

  const normalizeText = (value: any) =>
    String(value ?? "")
      .split(" ")
      .join("")
      .toLowerCase();

  const withDNone = (displayType: string) =>
    (displayType || "").includes("d-none")
      ? displayType
      : `${displayType || ""} d-none`.trim();

  /** Empty value keeps the field's original shape so the payload builder stays happy. */
  const emptyValueOf = (field: any) => {
    if (Array.isArray(field?.defaultValue)) return [];
    if (typeof field?.defaultValue === "boolean") return false;
    return "";
  };

  const isSelectedDependencyControl = (control: any, choice: any) => {
    if (!choice) return false;

    const optionIds = [choice?.id, choice?.optionDataID].filter(
      (optionId: any) => optionId !== undefined && optionId !== null
    );
    if (
      optionIds.some(
        (optionId: any) =>
          control?.optionID == optionId || control?.optionDataID == optionId
      )
    ) {
      return true;
    }

    return (
      !!choice?.value &&
      normalizeText(control?.value) === normalizeText(choice?.value)
    );
  };

  /** Same control, whether it comes from `fields` or from a dependency copy. */
  const isSameControl = (a: any, b: any) => {
    const aId = a?.controlDataID ?? a?.controlId;
    const bId = b?.controlDataID ?? b?.controlId;
    if (aId != null && bId != null) return aId == bId;

    return !!a?.systemFieldName && a?.systemFieldName === b?.systemFieldName;
  };

  /** Repeat blocks keep their dependency controls on the repeat field itself. */
  const getDependencyContext = () => {
    const sectionIndex =
      props?.sectionId != null && Array.isArray(props?.Inputs)
        ? FindIndex(props.Inputs, props.sectionId)
        : -1;
    const section =
      props?.Inputs?.[sectionIndex >= 0 ? sectionIndex : props?.index];
    const parentField = section?.fields?.[props?.fieldIndex];

    return parentField?.repeatFields?.[props?.repeatFieldIndex]
      ? {
          dependencyControls: parentField?.repeatDependencyControls,
          fields: parentField?.repeatFields,
        }
      : {
          dependencyControls: section?.dependencyControls,
          fields: section?.fields,
        };
  };

  /**
   * Clears the values a control leaves behind when its selection changes.
   *
   * Dependency fields hang off one specific option (DoYouHaveKit → "Ship to
   * Facility" → the address fields). Switching to another option only adds
   * `d-none`, so whatever the previous option captured still travels in the
   * submit payload — the payload is built from `fields`, and the dependency
   * copies mirror those same controls, so both sides are emptied here.
   *
   * Controls the newly selected option owns are left alone even when an older
   * option pointed at them too (e.g. "Ship to Facility" → "Ship to Patient"
   * both fill Address1), and dependency fields nested under an emptied field's
   * own options are cleared recursively.
   *
   * Runs before `props.onChange` so the mutations are part of the tree that
   * `showDep` clones downstream.
   */
  const resetDeselectedDependencyFields = (choice: any) => {
    const { dependencyControls, fields } = getDependencyContext();
    const changedFieldName =
      choice?.name ?? props?.systemFieldName ?? props?.name;

    if (!dependencyControls?.length || !changedFieldName) return;

    const selectedDepFields = dependencyControls
      .filter(
        (control: any) =>
          control?.name === changedFieldName &&
          isSelectedDependencyControl(control, choice)
      )
      .flatMap((control: any) => control?.dependecyFields ?? []);

    const isOwnedBySelectedOption = (field: any) =>
      selectedDepFields.some((selected: any) => isSameControl(selected, field));

    // The Oncology AOE barcode is a validated value that must survive while
    // the user temporarily selects a shipping option. `showDep` still hides
    // the field; only its committed value is preserved for switching back.
    const shouldPreserveDeselectedValue = (field: any) =>
      Number(props?.sectionId) === 137 &&
      changedFieldName === "DoYouHaveKit" &&
      field?.systemFieldName === "KitBarcode";

    /** The dependency copy and the `fields` entry are the same control. */
    const clearControl = (depField: any) => {
      if (!shouldPreserveDeselectedValue(depField)) {
        depField.defaultValue = emptyValueOf(depField);
        depField.selectedText = "";
      }
      depField.defaultValue = emptyValueOf(depField);
      depField.selectedText = "";
      // `visible` / `isSelectedDefault` stay untouched: they carry the API
      // configuration and only `d-none` is used to hide dependency fields.
      depField.displayType = withDNone(depField.displayType);

      fields?.forEach((field: any) => {
        if (field === depField || !isSameControl(depField, field)) return;
        if (isOwnedBySelectedOption(field)) return;
        if (shouldPreserveDeselectedValue(field)) return;

        field.defaultValue = emptyValueOf(field);
        field.selectedText = "";
      });
    };

    const visitedFieldNames = new Set<string>();

    const clearControlsOf = (fieldName: string, selectedChoice: any) => {
      if (!fieldName || visitedFieldNames.has(fieldName)) return;
      visitedFieldNames.add(fieldName);

      dependencyControls
        .filter(
          (control: any) =>
            control?.name === fieldName &&
            !isSelectedDependencyControl(control, selectedChoice)
        )
        .forEach((control: any) => {
          control?.dependecyFields?.forEach((depField: any) => {
            clearControl(depField);

            // An emptied field can no longer drive its own dependencies.
            depField?.options?.forEach((option: any) =>
              clearControlsOf(option?.name, null)
            );
          });
        });
    };

    clearControlsOf(changedFieldName, choice);
  };

  useEffect(() => {
    const timer = setTimeout(async () => {
      const fieldName = props?.systemFieldName;

      if (
        !fieldName ||
        touch ||
        // defaultSetMapRef.current[fieldName] ||
        !props?.RadioOptions?.length ||
        !isRepeatFieldVisible(props?.fields)
      ) {
        return;
      }

      const defaultSelectedOption = resolveSelectedRadioOption();

      // Apply tox specimen-type filter when SpecimenType has a default
      // selection (defaultValue and/or isSelectedDefault). Visibility only —
      // this runs on every remount/clone of the tox sections, so it must never
      // clear selections the user has already made.
      if (
        props?.ArrayReqId === 3 &&
        fieldName === "SpecimenType" &&
        defaultSelectedOption
      ) {
        applyToxTestingSpecimenTypeFilter(defaultSelectedOption, false);
      }

      // Explicit defaultValue is handled by load/patient logic; only auto-apply
      // when the field relies on isSelectedDefault with an empty defaultValue.
      if (props?.defaultValue) {
        if (props?.name === "BillingType" && defaultSelectedOption) {
          persistBillingInsuranceIds(defaultSelectedOption);
        }
        // defaultSetMapRef.current[fieldName] = true;
        return;
      }

      if (!defaultSelectedOption) return;

      const e = buildRadioChangeEvent(defaultSelectedOption, fieldName);
      props.fields.enableRule = "";

      if (props?.name === "BillingType") {
        await applyBillingTypeSelection(defaultSelectedOption);
      }

      props?.onChange(
        e,
        defaultSelectedOption.value,
        defaultSelectedOption.value,
        defaultSelectedOption?.label,
        false
      );

      // defaultSetMapRef.current[fieldName] = true;
      setTouch(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, [
    props.RadioOptions,
    props.systemFieldName,
    props.defaultValue,
    props.fields?.visible,
  ]);

  return (
    <>
      <div
        className={
          props?.parentDivClassName
            ? `${props?.parentDivClassName} mb-5`
            : "col-lg-6 col-md-6 col-sm-12 mb-5"
        }
        id={props?.name}
        ref={divElement}
        tabIndex={-1}
      >
        <label
          className={`d-block mb-2 fw-500 text-dark${
            props.required ? " required" : ""
          }`}
        >
          {t(props?.label)}
        </label>
        <div className="row g-2">
          {props?.RadioOptions?.map((choice: any) => {
            const phySign = store.getState()?.ReqReducer?.phySign;
            const isPhysicianSignAvailable = phySign;

            // Hide options with `optionDataId` 32 and 605 if `physicianSign` is not available
            if (
              !isPhysicianSignAvailable &&
              choice?.value?.toLowerCase() ===
                "Use Physician Signature".toLowerCase()
            ) {
              return null;
            }

            return (
              choice?.isVisable && (
                <label
                  key={choice?.id}
                  className={
                    props.name === "POCTestResult"
                      ? "col-12 fw-400 d-flex justify-content-start align-items-start"
                      : "col-md-6 fw-400 d-flex justify-content-start align-items-start"
                  }
                  htmlFor={choice?.name + choice?.id}
                  id={choice?.name + choice?.id}
                >
                  <input
                    className="form-check-input ifuser flex-column-auto h-20px w-20px"
                    type="radio"
                    name={
                      props?.name +
                      props?.repeatFieldIndex +
                      window.crypto.randomUUID()
                    }
                    id={choice?.id}
                    data-test-id={choice.label.split(" ").join("")}
                    data-nameCheck={props?.name}
                    data-name={choice?.name}
                    data-id={choice?.id}
                    data-optionDataId={choice?.optionDataID}
                    value={choice?.value}
                    checked={
                      props?.defaultValue
                        ? String(choice?.value || "")?.toLowerCase()
                          .split(" ")
                          .join("") ===
                        String(props?.defaultValue || "")?.toLowerCase()
                          .split(" ")
                          .join("")
                        : choice?.isSelectedDefault
                    }
                    defaultChecked={choice.isSelectedDefault ? true : false}
                    onChange={async (e: any) => {
                      const { value } = e.target;
                      const nameCheck = e.target.getAttribute("data-namecheck");
                      setTouch(true);

                      if (props.sectionId === 4) {
                        if (
                          choice?.value.toLowerCase() === "sample not collected"
                        ) {
                          // Temporary array to store backups
                          //  const validationBackupTemp: any[] = [];
                          props?.Inputs[
                            FindIndex(props.Inputs, 4)
                          ].fields.forEach((i: any) => {
                            if (
                              i.systemFieldName === "DateofCollection" ||
                              i.systemFieldName === "TimeofCollection" ||
                              i.systemFieldName === "DateReceived" ||
                              i.systemFieldName === "CollectorID" ||
                              i.systemFieldName === "StatOrder" ||
                              i.systemFieldName === "CollectedBy"
                            ) {
                              // Modify the field
                              i.visible = false;
                              // i.validationExpression = "";
                              i.defaultValue = "";
                            }
                          });
                        } else {
                          props?.Inputs[
                            FindIndex(props.Inputs, 4)
                          ].fields.forEach((i: any) => {
                            if (
                              i.systemFieldName === "DateofCollection" ||
                              i.systemFieldName === "TimeofCollection" ||
                              i.systemFieldName === "DateReceived" ||
                              i.systemFieldName === "CollectorID" ||
                              i.systemFieldName === "StatOrder" ||
                              i.systemFieldName === "CollectedBy"
                            ) {
                              // Set visibility back to true
                              i.visible = true;
                              // Restore the validation expression from the backup
                              const backup = props.validationBackup.find(
                                (b: any) =>
                                  b.systemFieldName === i.systemFieldName
                              );
                              if (backup) {
                                i.validationExpression =
                                  backup.validationExpression;
                              }
                            }
                          });
                          props?.Inputs[
                            FindIndex(props.Inputs, 4)
                          ].dependencyControls.forEach((i: any) => {
                            if (i.label == "Sample not collected") {
                              i.dependecyFields.forEach((j: any) => {
                                if (!j.displayType.includes("d-none")) {
                                  j.displayType =
                                    j.displayType + " " + "d-none";
                                }
                              });
                            }
                          });
                          props?.setInputs && props?.setInputs(props.Inputs);
                        }
                      } else { 
                        // Drop whatever the previously selected option collected
                        // so it never reaches the payload.
                        resetDeselectedDependencyFields(choice);
                      }

                      props?.onChange(
                        e,
                        value,
                        choice?.value,
                        props.systemFieldName === "SpecimenType" ||
                          props.systemFieldName === "BillingType"
                          ? choice?.label
                          : choice?.value
                      );

                      if (nameCheck === "BillingType") {
                        await applyBillingTypeSelection(choice);
                      }

                      // Check for Tox testing option based on specimen type
                      applyToxTestingSpecimenTypeFilter(choice);

                      if (props.sectionId === 89) {
                        const inputIndex = FindIndex(props.Inputs, 89);
                        const input = props?.Inputs?.[inputIndex];

                        if (!input?.fields) return;

                        props?.Inputs?.[inputIndex].fields.forEach(
                          (field: any) => {
                            if (
                              field.systemFieldName === "MedicalNessityPanel"
                            ) {
                              field.defaultValue = [choice];
                            }
                          }
                        );
                      }
                      //setting VMA checkbox true on selection of any Test from POC except POCTestingwasNotPerformed
                      if (
                        props?.sectionId === 36 &&
                        props?.systemFieldName !== "POCTestResult"
                      ) {
                        props?.Inputs[props.index]?.dependencyControls?.forEach(
                          (control: any) => {
                            control?.dependecyFields?.forEach((field: any) => {
                              if (field?.systemFieldName === "VMA") {
                                field.defaultValue = true;
                                props.setScreening(true);
                              }
                            });
                          }
                        );
                      }
                      //resetting dependency controls if POCTestingwasNotPerformed is selected
                      if (
                        props?.sectionId === 36 &&
                        props?.systemFieldName == "POCTestResult" &&
                        props?.fields?.defaultValue ===
                          "POC Testing was Not Performed"
                      ) {
                        props?.Inputs[props.index]?.dependencyControls?.forEach(
                          (control: any) => {
                            control?.dependecyFields?.forEach((field: any) => {
                              field.defaultValue = "";
                              props.setScreening(false);
                            });
                          }
                        );
                      }
                    }}
                    disabled={
                      props.sectionId === 45 || props.sectionId === 46
                        ? props.isEnable
                        : props?.sectionId === 20 ||
                            props.sectionId === 112 ||
                            props.sectionId === 89
                          ? props.noActiveMedication
                          : props?.disabled
                    }
                    required={props.required}
                  />
                  <span className="ps-2 text-break">{t(choice?.label)}</span>
                </label>
              )
            );
          })}
        </div>
        {props.error && (
          <div className="form__error">
            <span>{t(props.error)}</span>
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(Radio2);
